import axios from "utils/axios-private";

export const getUsers = () => {
  return {
    type: "GET_DROPDOWN_USERS",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/user/list`;
      axios
        .post(url, {}, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
